import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import { LogoMonogramBlack } from '../Brand';

import { headerClean } from '../../helpers';

const TeaserCaseStudy = ({ node }) => {
  const headline = headerClean(node.data.title.text);
  const href = `/technical-assistance/case-studies/${node.uid}/`;
  const excerpt = node.data?.teaser?.text || '';

  // Placeholder client/country. Isolated here so swapping to real Prismic
  // fields later is a one-place change (see spec 2026-06-30).
  const meta = {
    client: 'Premier Credit',
    country: 'Kenya',
  };

  let mainImage = null;
  if (node.data?.main_image?.gatsbyImageData) {
    mainImage = node.data.main_image;
  }
  else if (node.data?.featured_image?.gatsbyImageData) {
    mainImage = node.data.featured_image;
  }

  return (
    <article className="flex flex-col md:flex-row md:items-start gap-6 md:gap-10">
      {/* Thumbnail — fixed-width column on desktop, native aspect ratio.
          The title (below) is the real focusable link; this image link is
          decorative/duplicate, mirroring the prior component's a11y pattern. */}
      <div className="md:w-[320px] md:shrink-0">
        {mainImage?.gatsbyImageData ? (
          <Link to={href} className="block" aria-hidden="true" tabIndex="-1">
            <GatsbyImage
              image={mainImage.gatsbyImageData}
              alt=""
              objectFit="contain"
              className="w-full"
            />
          </Link>
        ) : (
          <Link
            to={href}
            className="block bg-nordic-blue-500 px-12 py-10"
            aria-hidden="true"
            tabIndex="-1"
          >
            <div className="aspect-w-3 aspect-h-4">
              <LogoMonogramBlack className="max-w-[8rem] mx-auto flex items-center" />
            </div>
          </Link>
        )}
      </div>

      {/* Text */}
      <div className="md:flex-1">
        <p className="font-trade text-[1rem] sm:text-xs 2xl:text-[1.3rem] leading-[1.4] 2xl:leading-[1.2] mb-2">
          {meta.client} &middot; {meta.country}
        </p>
        <h3>
          <Link to={href} className="no-underline">
            <span
              className="text-lg 2xl:text-[2.5rem] 2xl:leading-[1.15]"
              dangerouslySetInnerHTML={{ __html: headline }}
            />
          </Link>
        </h3>
        {excerpt && (
          <p className="text-sm mt-3">
            {excerpt}
          </p>
        )}
        <Link
          to={href}
          className="block text-sm mt-4"
          aria-hidden="true"
          tabIndex="-1"
        >
          Read more
        </Link>
      </div>
    </article>
  )
};

TeaserCaseStudy.propTypes = {
  node: PropTypes.shape({}).isRequired,
};

export default TeaserCaseStudy;
